import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ACTIVE_ROLE_KEY = "fbclub_active_role";

export const getActiveRole = () => {
  try { return sessionStorage.getItem(ACTIVE_ROLE_KEY) || null; } catch { return null; }
};

export const setActiveRoleStorage = (role) => {
  try {
    if (role) sessionStorage.setItem(ACTIVE_ROLE_KEY, role);
    else sessionStorage.removeItem(ACTIVE_ROLE_KEY);
  } catch { /* ignore */ }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach X-Active-Role header on every request so backend can override permissions
api.interceptors.request.use((config) => {
  const active = getActiveRole();
  if (active) {
    config.headers = config.headers || {};
    config.headers["X-Active-Role"] = active;
  }
  return config;
});

/**
 * Descarga un recurso binario (foto, archivo) usando `fetch` en vez de axios.
 * Axios + `responseType: "blob"` + 4xx lanza un error sincrónico
 * ("responseText is not accessible when responseType is 'blob'") que aparece
 * como "Uncaught runtime errors" en el overlay de CRA aunque la promesa esté
 * cazada. Usar fetch nativo lo evita.
 *
 * Devuelve un object URL o `null` si la respuesta no es 2xx.
 */
export async function fetchBlobUrl(path) {
  const url = path.startsWith("http") ? path : `${API}${path.startsWith("/") ? path : `/${path}`}`;
  const headers = {};
  const active = getActiveRole();
  if (active) headers["X-Active-Role"] = active;
  try {
    const res = await fetch(url, { credentials: "include", headers });
    if (!res.ok) return null;
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

export default api;
